import { signal } from '@angular/core';

export const showServerDownModal = signal(false);

export function isServerDownError(error: { message: string; status: number }) {
  return error.message && error.status !== 500 && isServerDownErrorMessage(error.message);
}

export function isServerDownErrorMessage(message: string) {
  return message.includes('Http failure response for');
}
